import { useEffect, useState, RefObject, useCallback } from 'react';

function useWidth(elementRef?: RefObject<HTMLDivElement>) {
  const [width, setWidth] = useState<number | null>(null);

  const updateWidth = useCallback(() => {
    if (elementRef && elementRef.current) {
      const { width } = elementRef.current.getBoundingClientRect();
      setWidth(width);
    }
  }, [elementRef]);

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, [updateWidth]);

  return width;
}

export default useWidth;
